import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useState,
} from "react"
import { Salary } from "../interface/interfaces"
// mettre les valeurs que j'attend
export interface IStore {
  role: string
  range: string[]
  paris: boolean
  province: boolean
  management: boolean
  salaries: Salary[]
}
//default value
const defaultValue: IStore = {
  role: null,
  range: [],
  paris: false,
  province: false,
  management: false,
  salaries: [],
}

const defaultUpdate: Dispatch<SetStateAction<IStore>> = () => defaultValue

export const StoreContext = createContext({
  state: defaultValue,
  update: defaultUpdate,
})

export function StoreProvider(props: PropsWithChildren<{}>) {
  const [state, update] = useState(defaultValue)
  return <StoreContext.Provider value={{ state, update }} {...props} />
}
